import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function Cart() {
    const {
        cartItems,
        removeFromCart,
        clearCart,
        increaseQty,
        decreaseQty,
    } = useCart();

    const total = cartItems.reduce(
        (sum, item) => sum + item.variant.price * item.qty,
        0
    );

    /* EMPTY CART */
    if (cartItems.length === 0) {
        return (
            <div className="max-w-md mx-auto px-6 py-32">
                <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
                    <h2 className="text-2xl font-bold mb-2">🛒 Cart खाली है</h2>
                    <p className="text-gray-600 mb-6">
                        आपने अभी कोई product add नहीं किया है
                    </p>
                    <Link
                        to="/products"
                        className="inline-block bg-[#7a0c18] text-white px-6 py-3 rounded-lg font-semibold"
                    >
                        Products देखें
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto px-4 pt-28 pb-32">
            {/* WHITE CARD */}
            <div className="bg-white rounded-2xl shadow-xl p-6">

                {/* HEADER */}
                <h1 className="text-2xl md:text-3xl font-bold mb-6 flex items-center gap-3">
                    🛒 Your Cart
                    <span className="text-sm bg-gray-200 px-3 py-1 rounded-full">
                        {cartItems.length} items
                    </span>
                </h1>

                {cartItems.map((item, index) => (
                    <div
                        key={`${item.product.id}-${item.variant.weight}`}
                        className="border-b py-5 flex flex-col gap-4 sm:flex-row sm:items-center"
                    >
                        {/* IMAGE + NAME */}
                        <div className="flex items-center gap-4">
                            <img
                                src={item.variant.image}
                                alt={item.product.name}
                                className="w-20 h-20 object-contain"
                            />
                            <div>
                                <h3 className="font-semibold text-lg">
                                    {item.product.name}
                                </h3>
                                <p className="text-sm text-gray-600">
                                    {item.variant.weight}
                                </p>
                            </div>
                        </div>

                        {/* QTY */}
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => decreaseQty(index)}
                                disabled={item.qty === 1}
                                className={`w-8 h-8 rounded-full border text-lg font-bold
                                    ${item.qty === 1 ? "opacity-40" : ""}
                                `}
                            >
                                −
                            </button>

                            <span className="font-semibold text-lg">
                                {item.qty}
                            </span>

                            <button
                                onClick={() => increaseQty(index)}
                                className="w-8 h-8 rounded-full border text-lg font-bold"
                            >
                                +
                            </button>
                        </div>

                        {/* PRICE + REMOVE */}
                        <div className="flex items-center justify-between sm:ml-auto gap-6">
                            <p className="font-bold text-lg">
                                ₹ {item.variant.price * item.qty}
                            </p>

                            <button
                                onClick={() => removeFromCart(index)}
                                className="text-red-600 text-xl font-bold"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                ))}

                {/* TOTAL */}
                <div className="mt-6 text-xl font-bold">
                    Total: ₹ {total}
                </div>

                {/* ✅ ACTION BUTTONS (VISIBLE ON ALL SCREENS) */}
                <div className="mt-8 flex flex-col sm:flex-row gap-4">
                    <Link
                        to="/products"
                        className="border px-6 py-3 rounded-lg font-semibold text-center"
                    >
                        Add More Products
                    </Link>

                    <button
                        onClick={() => {
                            if (window.confirm("Cart clear करना चाहते हैं?")) {
                                clearCart();
                            }
                        }}
                        className="border px-6 py-3 rounded-lg"
                    >
                        Clear Cart
                    </button>

                    <a
                        href={`https://wa.me/+919752772880?text=${encodeURIComponent(
                            `मेरा ऑर्डर:\n${cartItems
                                .map(
                                    i =>
                                        `${i.product.name} (${i.variant.weight}) x ${i.qty} = ₹${i.variant.price * i.qty}`
                                )
                                .join("\n")}\n\nTotal: ₹${total}`
                        )}`}
                        target="_blank"
                        rel="noreferrer"
                        className="bg-[#25D366] text-white px-6 py-3 rounded-lg font-semibold text-center"
                    >
                        WhatsApp Checkout
                    </a>
                </div>
            </div>
        </div>
    );
}
